import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./styles/theme.css";
import "./App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import SEO from "./components/SEO";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Review from "./pages/Review";
import Contact from "./pages/Contact";
import DestinationPage from "./pages/DestinationPage";
import FloatingContact from "./components/FloatingContact";
import "./styles/ReferenceTheme.css";



// Component to scroll to top on route change
function ScrollToTopOnRouteChange() {
  const location = useLocation();
  
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [location]);
  
  return null;
}

// Dynamic SEO based on route
function DynamicSEO() {
  const location = useLocation();
  
  const getSEOData = () => {
    const path = location.pathname;
    
    const seoData = {
      '/': {
        title: 'Home',
        description: 'Bhole Cab Service - Reliable, comfortable rides across Vadodara. Book your cab for local travel, outstation trips, airport transfers, and corporate travel.',
        keywords: 'Bhole Cab Service, cab service Vadodara, taxi Vadodara, airport pickup, round trip'
      },
      '/about': {
        title: 'About Us',
        description: 'Learn about Bhole Cab Service - Your trusted cab service provider in Vadodara with years of experience, professional drivers, and customer-first approach.',
        keywords: 'about Bhole Cab, cab service Vadodara, professional drivers, trusted cab service'
      },
      '/services': {
        title: 'Our Services',
        description: 'Explore Bhole Cab Service\'s wide range of transportation services - One Way Trip, Round Trip, Local Taxi, Airport Pick & Drop, Wedding & Event Cab, and Corporate Travel.',
        keywords: 'cab services, one way taxi, round trip, local taxi Vadodara, airport pickup, wedding cab'
      },
      '/gallery': {
        title: 'Gallery',
        description: 'Explore our fleet and services through our photo gallery. See our clean, well-maintained vehicles and professional cab service in action.',
        keywords: 'cab gallery, taxi fleet, vehicle photos, Bhole Cab images'
      },
      '/review': {
        title: 'Reviews',
        description: 'Read what our customers say about Bhole Cab Service. Real reviews from real people who have traveled with us in Vadodara.',
        keywords: 'customer reviews, Bhole Cab reviews, taxi reviews, Vadodara cab service reviews'
      },
      '/destinations/statue-of-unity': { title: 'Vadodara to Statue of Unity Taxi Cabs Booking', description: 'Book a comfortable cab from Vadodara to the Statue of Unity with Bhole Cab Service.', keywords: 'Vadodara to Statue of Unity cab, taxi booking' },
      '/destinations/pavagadh': { title: 'Vadodara to Pavagadh Taxi Cabs Booking', description: 'Plan your Pavagadh temple trip from Vadodara with Bhole Cab Service.', keywords: 'Vadodara to Pavagadh cab, Pavagadh taxi' },
      '/destinations/poicha': { title: 'Vadodara to Poicha Cabs - Best Taxi Service 24*7', description: 'Book a cab from Vadodara to Poicha Nilkanth Dham with Bhole Cab Service.', keywords: 'Vadodara to Poicha cab, Poicha taxi' },
      '/destinations/dakor': { title: 'Vadodara to Dakor Taxi Cabs Booking', description: 'Arrange a private cab from Vadodara to Dakor Ranchhodraiji Temple.', keywords: 'Vadodara to Dakor taxi, Dakor cab' },
      '/destinations/kavi-kamboi-mahadev-mandir': { title: 'Vadodara to Kavi Kamboi Taxi Cabs Booking from Rs 2000', description: 'Book a cab from Vadodara to Kavi Kamboi Mahadev Mandir.', keywords: 'Vadodara to Kavi Kamboi cab, Kavi Kamboi taxi' },
      '/contact': {
        title: 'Contact Us',
        description: 'Get in touch with Bhole Cab Service. Book your cab, ask questions, or give feedback. We\'re here to help you with all your travel needs.',
        keywords: 'contact Bhole Cab, book cab, Vadodara taxi contact, cab service number'
      }
    };
    
    return seoData[path] || seoData['/'];
  };
  
  const seo = getSEOData();
  
  return (
    <SEO 
      title={seo.title}
      description={seo.description}
      keywords={seo.keywords}
      type="website"
    />
  );
}

function AppContent() {
  return (
    <div className="app">
      <DynamicSEO />
      <ScrollToTopOnRouteChange />
      <Header />
      
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/review" element={<Review />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/destinations/:slug" element={<DestinationPage />} />
        </Routes>
      </main>

      <Footer />

      {/* <ScrollToTop /> */}
      <FloatingContact />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;